import React from 'react';

const Icon = ({ size = '88', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 88 88" fill="none" {...other}>
            <path
                d="M28.457 23.811a27.547 27.547 0 0 0-10.954 15.304m8.933 28.546A27.388 27.388 0 0 0 44 74.001a27.387 27.387 0 0 0 17.404-6.208m9.133-28.533c-1.755-6.447-5.796-11.95-11.198-15.588"
                stroke="white"
                strokeWidth="5"
                strokeLinecap="round"
            />

            <circle cx="44" cy="20.667" r="7.5" stroke="white" strokeWidth="5" />

            <circle cx="20.667" cy="54" r="7.5" stroke="white" strokeWidth="5" />

            <circle cx="67.333" cy="54" r="7.5" stroke="white" strokeWidth="5" />
        </svg>
    );
};
export default React.memo(Icon);
